(() => {
  const dialog = document.getElementById('BagNotification');
  if (!dialog || typeof dialog.showModal !== 'function' || !window.fetch) return;
  let returnFocus;
  let adding = false;
  dialog.addEventListener('close', () => {
    document.body.classList.remove('bag-notification-open');
    returnFocus?.focus({ preventScroll: true });
    returnFocus = null;
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-bag-close]')) dialog.close();
    if (event.target.closest('a[href="#FooterCountry"]')) {
      returnFocus = null;
      dialog.close();
      document.getElementById('FooterCountry')?.focus();
    }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  function initialize(root = document) {
    root.querySelectorAll('.product-form').forEach(form => {
      if (form.dataset.bagReady) return;
      form.dataset.bagReady = 'true';
      form.addEventListener('submit', async event => {
        const button = form.querySelector('[data-add-button]');
        // Shopify owns accelerated checkout. Intercept only our Add to bag button.
        if (!button || event.submitter !== button || event.defaultPrevented) return;
        event.preventDefault();
        if (adding || button.disabled) return;
        adding = true;
        const error = form.querySelector('[data-bag-error]');
        error.hidden = true;
        const body = new FormData(form);
        body.set('sections', 'cart-notification');
        body.set('sections_url', window.location.pathname);
        const controls = [...form.querySelectorAll('button, input, select')].map(element => [element, element.disabled]);
        controls.forEach(([element]) => { element.disabled = true; });
        const label = button.textContent;
        button.textContent = 'Adding to your bag...';
        form.setAttribute('aria-busy', 'true');
        let added = false;
        try {
          const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
            method: 'POST', headers: { Accept: 'application/json' }, body
          });
          if (!response.ok) throw new Error('Cart update was not confirmed');
          added = true;
          const result = await response.json();
          let html = result.sections?.['cart-notification'];
          if (!html) {
            // A section can fail even when the add succeeded. Retry only the read.
            const url = new URL(window.location.href);
            url.searchParams.set('sections', 'cart-notification');
            const refreshed = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!refreshed.ok) throw new Error('Could not refresh the bag');
            html = (await refreshed.json())['cart-notification'];
          }
          const fresh = new DOMParser().parseFromString(html || '', 'text/html').querySelector('#BagNotification');
          if (!fresh) throw new Error('Missing bag notification');
          const count = Number(fresh.dataset.cartCount);
          if (!Number.isSafeInteger(count) || count < 1) throw new Error('Invalid bag count');
          const lines = [...fresh.querySelectorAll('[data-item-key]')];
          const selected = lines.find(line => line.dataset.itemKey === result.key) || lines.find(line => line.dataset.variantId === String(body.get('id')));
          lines.forEach(line => { if (line === selected) line.hidden = false; else line.remove(); });
          dialog.replaceChildren(...fresh.childNodes);
          document.querySelectorAll('.cart-count').forEach(element => { element.textContent = String(count); });
          document.querySelectorAll('.cart-link').forEach(element => { element.setAttribute('aria-label', `Bag, ${count} items`); });
          returnFocus = button;
          dialog.showModal();
          document.body.classList.add('bag-notification-open');
        } catch {
          // Never repeat a potentially successful add after a network failure.
          error.querySelector('span').textContent = added
            ? 'Added to your bag, but the summary could not load.'
            : 'We could not confirm the requested quantity was added.';
          error.hidden = false;
        } finally {
          controls.forEach(([element, disabled]) => { element.disabled = disabled; });
          button.textContent = label;
          form.removeAttribute('aria-busy');
          adding = false;
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
